import { Box, Card, CardContent, Typography, Chip, Stack, Button, CircularProgress } from '@mui/material'
import { ProductsImgProps } from './FotosDesktop'
import TableDataPagination from '../ABMProducts/components/Table/TableFooter'
import NoResults from '../../../components/Common/NoResults'
import DetalleFotos from './detalleFotos'
import TablaServerPagination from '../../../components/Common/utils/paginator/serverPaginator'

const FotosMobile = ({
  items,
  paginator,
  contadorEstado,
  loading,
  loadingButtons,
  sincronizarFotos,
  eliminarCaptions
}: ProductsImgProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
      {items.length === 0 ? (
        <Box sx={{ border: '1px solid', borderColor: 'divider' }}>
          <NoResults />
        </Box>
      ) : (
        items.map((p) => {
          const contadores = contadorEstado(p.fotosBuscadorImagenes || [])
          const haySinCaption = p.fotosBuscadorImagenes?.some((foto) => foto.caption === null)
          const hayAlgunaConCaption = p.fotosBuscadorImagenes?.some((foto) => foto.caption !== null)
          return (
            <Card
              key={p.idProducto}
              sx={{
                '&:hover': {
                  boxShadow: 3
                }
              }}
            >
              {/* ENCABEZADO: Foto + Info */}
              <Box sx={{ display: 'flex' }}>
                {/* Datos a la derecha */}
                <CardContent sx={{ flex: 1, py: 1.5, px: 1.5 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
                      {`${p.nombre} (${p.codProducto})`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                      <strong>Local:</strong> {`${p.nombreLocal} (${p.codLocal})`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                      <strong>Rubro:</strong> {p.nombreRubro}
                    </Typography>

                    {/* Chips de estado */}
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
                      {contadores.pendiente > 0 && (
                        <Chip
                          label={`Pendiente (${contadores.pendiente})`}
                          color="warning"
                          size="small"
                          sx={{ fontSize: '0.7rem' }}
                        />
                      )}
                      {contadores.caption > 0 && (
                        <Chip
                          label={`Procesada (${contadores.caption})`}
                          color="success"
                          size="small"
                          sx={{ fontSize: '0.7rem' }}
                        />
                      )}
                      {contadores.error > 0 && (
                        <Chip
                          label={`Error (${contadores.error})`}
                          color="error"
                          size="small"
                          sx={{ fontSize: '0.7rem' }}
                        />
                      )}
                    </Stack>

                    {/* Botones de acción */}
                    {p.fotosBuscadorImagenes?.length > 0 && (
                      <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 0.5 }}>
                        {haySinCaption && (
                          <Button
                            onClick={() => sincronizarFotos(1000, 0, p.idProducto)}
                            variant="contained"
                            color="success"
                            size="small"
                            disabled={loadingButtons[`caption-producto-${p.idProducto}`] || loading}
                            fullWidth
                            sx={{ fontSize: '0.7rem', py: 0.5 }}
                          >
                            {loadingButtons[`caption-producto-${p.idProducto}`] ? (
                              <CircularProgress size={18} color="inherit" />
                            ) : (
                              'generar captions'
                            )}
                          </Button>
                        )}
                        {hayAlgunaConCaption && (
                          <Button
                            onClick={() => eliminarCaptions(0, p.idProducto)}
                            variant="contained"
                            color="error"
                            size="small"
                            disabled={loadingButtons[`eliminar-producto-${p.idProducto}`] || loading}
                            fullWidth
                            sx={{ fontSize: '0.7rem', py: 0.5 }}
                          >
                            {loadingButtons[`eliminar-producto-${p.idProducto}`] ? (
                              <CircularProgress size={18} color="inherit" />
                            ) : (
                              'eliminar captions'
                            )}
                          </Button>
                        )}
                      </Stack>
                    )}
                  </Box>
                </CardContent>
              </Box>

              {/* DETALLE DE FOTOS: Sección separada debajo */}
              {p.fotosBuscadorImagenes?.length > 0 && (
                <Box sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
                  <DetalleFotos
                    fotos={p.fotosBuscadorImagenes}
                    loading={loading}
                    loadingButtons={loadingButtons}
                    sincronizarFotos={sincronizarFotos}
                    eliminarCaptions={eliminarCaptions}
                  />
                </Box>
              )}
            </Card>
          )
        })
      )}
      <TablaServerPagination component={'td'} label="Productos por página" paginator={paginator} />
    </Box>
  )
}

export default FotosMobile
